import debounce from '../utils/debounce';
import gsap from 'gsap';

class Cursor {
  constructor() {
    if (window.innerWidth > 768) {
      this.cursor = document.querySelector('.js-cursor');
      this.cursorText = document.querySelector('.cursor-circle__text');
      this.cursorImage = document.querySelector('.cursor-circle__image');
      this.cursorLogo = document.querySelector('.cursor-circle__svg use');
      this.triggers = document.querySelectorAll('.js-cursor-trigger');
      this.hideCursor = document.querySelectorAll('.js-hide-cursor');
      this.currentText;

      this.root = document.querySelector(':root');

      this.frame = document.querySelector('.js-frame');

      this.body = document.body;

      this.updateCursor = debounce(this.updateCursor.bind(this, this.cursor), 1);
      this.body.addEventListener('mousemove', this.updateCursor);

      this.focus();

      this.triggers.forEach(element => {
        this.preloadImages(element);

        element.onmouseover = this.updateCursorStyleIn.bind(this);
        element.onmouseout = this.updateCursorStyleOut.bind(this);
      });
    }
  }

  preloadImages(element) {
    if (element.dataset['surpriseImage']) {
      const img = new Image();
      img.src = element.dataset['surpriseImage'];
    }
  }

  focus() {
    const elements = document.querySelectorAll('.frame__asset-bucket__asset-mod');

    const actions = {
      activate: function(el) {
        const assetBucket = el.closest('.frame__asset-bucket__assets');
        const dots = el.closest('.frame__asset-bucket').querySelectorAll('.bg-frame__nav__dot');
        const selectedIndex = Array.from(assetBucket.children).indexOf(el);

        if (dots.length) {
          const currentDot = dots[selectedIndex];
          dots.forEach(item => {
            item.classList.remove('dot-is-active');
          });
          currentDot.classList.add('dot-is-active');
        }

        elements.forEach(item => {
          item.classList.remove('image-is-active');
        });

        el.classList.add('image-is-active');
      },
      deactivate: function() {
        Array.from(document.querySelectorAll('.bg-frame__nav__dot')).forEach(el =>
          el.classList.remove('dot-is-active'),
        );
      },
    };

    const placeholderPosition = function(el) {
      el.addEventListener('focus', function() {
        actions.activate(this);
      });
      el.addEventListener('blur', function() {
        actions.deactivate(this);
      });
    };

    elements.forEach(function(el) {
      placeholderPosition(el);
    });
  }

  updateCursorStyleIn(event) {
    if (event.currentTarget.dataset['surpriseImage']) {
      this.cursor.classList.add('show-cursor-image');
      this.cursorImage.setAttribute('src', event.currentTarget.dataset['surpriseImage']);
    } else if (event.currentTarget.dataset['surpriseLogo']) {
      this.cursorLogo.setAttributeNS(
        'http://www.w3.org/1999/xlink',
        'xlink:href',
        event.currentTarget.dataset['surpriseLogo'],
      );
      this.body.classList.add('show-cursor-logo');
    } else if (event.currentTarget.classList.contains('js-hide-cursor')) {
      //
    } else if (event.currentTarget.dataset['surpriseText'] !== this.currentText) {
      this.currentText = event.currentTarget.dataset['surpriseText'];
      this.cursorText.innerHTML = this.currentText;
      this.body.classList.add('show-cursor-text');
    }
    if (
      event.currentTarget.dataset['surpriseText'] ||
      event.currentTarget.dataset['surpriseLogo']
    ) {
      gsap.to('.js-cursor', {
        duration: 0.5,
        ease: 'power3.out',
        css: {
          width: '200px',
          height: '200px',
          scale: '1',
        },
      });
    }
  }
  updateCursorStyleOut() {
    this.cursor.classList.remove('show-cursor-image');
    this.cursor.classList.remove('hide-cursor');
    this.currentText = '';
    this.cursorText.innerHTML = this.currentText;
    this.body.classList.remove('show-cursor-text');
    this.body.classList.remove('show-cursor-logo');

    gsap.to('.js-cursor', {
      duration: 0.5,
      ease: 'power3.out',
      css: {
        width: '50px',
        height: '50px',
        scale: '1',
        rotate: '0',
        opacity: 1,
      },
    });
  }

  updateImages(event) {
    this.images = document.querySelectorAll('.bucket-is-active .frame__asset-bucket__asset-mod');
    this.dots = document.querySelectorAll('.bucket-is-active .bg-frame__nav__dot');

    if (this.images.length) {
      const x = event.clientX;
      const width = this.frame.clientWidth;
      const offset = this.frame.offsetLeft;
      const percentage = (x - offset) / width + 0.5;
      const mapPercentage = percentage < 0 ? 0 : percentage > 0.99 ? 0.99 : percentage;
      const selectedIndex = Math.floor(this.images.length * mapPercentage);
      const currentProject = this.images[selectedIndex];

      currentProject.focus();
    }
  }

  updateCursor(el, event) {
    if (event.target.classList.contains('js-hide-cursor')) {
      const offsetLeft = event.target.getBoundingClientRect().left;
      const offsetTop = event.target.getBoundingClientRect().top;
      gsap.to('.js-cursor', {
        duration: 0.5,
        ease: 'power3.out',
        css: {
          width: '200px',
          height: '200px',
          left: `${offsetLeft + 100}px`,
          top: `${offsetTop + 100}px`,
          scale: '1',
          opacity: 0,
          color: 'var(--c-spot)',
        },
      });
    } else {
      this.updateImages(event);
      gsap.to(el, {
        duration: 0.5,
        ease: 'power3.out',
        css: {
          left: event.clientX,
          top: event.clientY,
          color: 'var(--c-text)',
        },
      });
    }
  }
}

export default Cursor;
